define.alias("shared/utils/formatters/pin-from-dynamo", "preview-grid/utils/formatters/pin-from-dynamo");